"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FieldPreviewNumber;

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _types = require("../../../../../../../types");

var _usePkpass2 = require("../../../../usePkpass");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyle = function getStyle(style) {
  switch (style) {
    case _types.PkpassNumberStyleTypes.PKNumberStylePercent:
      return 'percent';

    case _types.PkpassNumberStyleTypes.PKNumberStyleDecimal:
    default:
      return 'decimal';
  }
};

function FieldPreviewNumber(props) {
  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      language = _usePkpass.language;

  var value = props.value,
      style = props.style;

  if (style === _types.PkpassNumberStyleTypes.PKNumberStyleSpellOut) {
    return /*#__PURE__*/React.createElement("span", null);
  }

  if (style === _types.PkpassNumberStyleTypes.PKNumberStyleScientific) {
    return /*#__PURE__*/React.createElement("span", null, Number(value).toExponential().replace(/\+/g, '').toUpperCase());
  }

  var options = {
    style: getStyle(style),
    value: Number(value)
  };
  return /*#__PURE__*/React.createElement(_reactIntl.IntlProvider, {
    locale: language
  }, /*#__PURE__*/React.createElement(_reactIntl.FormattedNumber, options));
}

FieldPreviewNumber.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
};
//# sourceMappingURL=FieldPreviewValueNumber.js.map